var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_608",
    "data-name": "Groupe 608",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.642,
    height: 41.445,
    viewBox: "0 0 32.642 41.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_607",
    "data-name": "Groupe 607",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_535",
    "data-name": "Trac\\xE9 535",
    d: "M-6.8,0-24.01,30.412v.8H-5.145v6.86L-10.8,40.931v.515H8.4v-.515L4.573,38.073v-6.86H8.632V30.126H4.573V16.464H4.059l-9.2,3.944v9.718H-22.752L4.859,0Z",
    transform: "translate(24.01)",
    fill: "#e30613"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.6e4d3e47ffdef20114e532285c66cfd6.svg";
export { ForwardRef as ReactComponent };